import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 371.52 371.52" style="enable-background:new 0 0 371.52 371.52;" xml:space="preserve">
<g>
	<g>
		<polygon points="371.52,30.176 341.333,0.011 185.771,155.595 30.187,0.011 0,30.176 155.584,185.76 0,341.344 30.187,371.509 
			185.771,215.925 341.333,371.509 371.52,341.344 215.936,185.76 		"/>
	</g>
</g>
</svg>
`,
      }}
    />
  );
};
